import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Button
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import { Helmet } from "react-helmet-async";

import { FiChevronDown } from "react-icons/fi";

import useStyles from "./styles";
import TextInput from "Components/TextInput";
import Spinner from "Components/Spinner";
import { CEP, CPFCNPJ, PHONE, CPF } from "Components/NumberFormat";

import actions from "store/actions";

import _ from "lodash";

import { UserCreateState } from "store/reducers/user/create";

import ls from "Localization";
import { DatePicker } from "@mui/x-date-pickers";
import { State } from "store/reducers";
import Select from "Components/Select";
import { UserStatus } from "Types/User";
import AutoComplete from "Components/AutoComplete";
import { UserState } from "store/reducers/user";
import { useNavigate } from "react-router-dom";

let debounceFindCompany: (() => any) & _.Cancelable;

function UserCreate() {
	const navigate = useNavigate();
	const dispatch = useDispatch<any>();
	const classes = useStyles({});

	useEffect(() => {
		// dispatch(actions.user.create.clearValues());
	}, [dispatch]);

	const [showInfoPanel, setShowInfoPanel] = useState(true);
	const [zipCodeLoading, setZipCodeLoading] = useState(false);
	const [checkZipCode, setCheckZipCode] = useState(false);

	const {
		loading,
		errors,
		email,
		name,
		lastname,
		role,
		cpf,
		userStatus,
		phoneNumber,
		birthDate,
		address
	} = useSelector<State, UserCreateState>(s => s.userCreate);

	const { loading: userLoading } = useSelector<State, UserState>(s => s.user);

	const { street, number, complement, neighborhood, city, state, zipCode } =
		address;

	useEffect(() => {
		if (checkZipCode && zipCode?.length === 8) {
			setZipCodeLoading(true);
			fetch(`https://viacep.com.br/ws/${zipCode}/json/`)
				.then(res => res.json())
				.then(json => {
					if (json) {
						dispatch(
							actions.user.create.setValue({
								address: {
									street: json.logradouro,
									number: "",
									complement: json.complemento,
									neighborhood: json.bairro,
									city: json.localidade,
									state: json.uf,
									zipCode
								}
							})
						);
					}
					setZipCodeLoading(false);
				})
				.catch(err => {
					console.log(err);
					setZipCodeLoading(false);
				});
		}
	}, [zipCode]);

	const findCompany = (name: any, callback: any) => {
		if (name.length >= 3) {
			if (debounceFindCompany) debounceFindCompany.cancel();

			debounceFindCompany = _.debounce(() => {
				dispatch(
					actions.mei.getMeis(
						0,
						10,
						`&filters[searchText]=${name}&filters[type]=${
							role === "mei" ? 0 : 1
						}`,
						undefined,
						false,
						false,
						(errors, models) => {
							if (models) {
								callback(
									models.map(c => ({
										id: c._id,
										label: `${c.businessName}`
									}))
								);
							} else {
								callback([]);
							}
						}
					)
				);
			}, 1000);

			debounceFindCompany();
		}
	};

	const handleChange = (id: string, value: any) => {
		const v = { [id]: value };

		dispatch(actions.user.create.setValue(v));
	};

	const handleAddressChange = (id: string, value: any) => {
		if (id === "zipCode") setCheckZipCode(true);
		const v = { ...address, [id]: value };

		if (id === "state") {
			v.state = value?.toUpperCase() ?? "";
		}

		handleChange("address", v);
	};

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		dispatch(
			actions.user.create.createUser(err => {
				if (err) {
					console.log(err);
					if (err.code) {
						alert(err.code);
					} else if (typeof err === "string") alert(err);
					else alert(JSON.stringify(err));
				} else {
					navigate("/Dashboard/User");
				}
			})
		);
	};

	return (
		<form onSubmit={handleSubmit} noValidate>
			<Helmet>
				<title>
					{ls.clientCreate} | {ls.appName}
				</title>
			</Helmet>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Accordion
						TransitionProps={{ unmountOnExit: true }}
						expanded={showInfoPanel}
						onChange={() => setShowInfoPanel(prev => !prev)}
					>
						<AccordionSummary
							expandIcon={<FiChevronDown />}
							aria-controls="finishes-content"
							id="finishes-header"
						>
							<Typography className={classes.heading} variant="h6">
								{ls.clientCreate}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Grid container spacing={2}>
								<Grid item xs={12} sm={6} md={4} lg={3}>
									<TextInput
										errors={errors}
										id="name"
										name="name"
										value={name}
										required
										onChange={handleChange}
									/>
								</Grid>

								<Grid item xs={12} sm={6} md={4} lg={3}>
									<TextInput
										errors={errors}
										id="lastname"
										name="lastName"
										value={lastname}
										required
										onChange={handleChange}
									/>
								</Grid>

								<Grid item xs={12} sm={6} md={4} lg={3}>
									<TextInput
										errors={errors}
										id="email"
										name="email"
										value={email}
										required
										onChange={handleChange}
									/>
								</Grid>

								<Grid item xs={12} sm={6} md={4} lg={3}>
									<Select
										errors={errors}
										id="role"
										name="role"
										required
										value={role}
										onChange={handleChange}
										options={[
											{
												id: "admin",
												value: "Administrador"
											},
											{
												id: "logisticOperator",
												value: "Operador Logístico"
											},
											{
												id: "nfseController",
												value: ls.nfseController
											},
											{
												id: "mei",
												value: "MEI"
											}
										]}
									/>
								</Grid>

								{["mei", "logisticOperator", "nfseController"].includes(role) && (
									<Grid item xs={12} sm={6} md={4} lg={3}>
										<AutoComplete
											id="mei"
											name="company"
											errors={errors}
											onChange={handleChange}
											loadOptions={findCompany}
											loading={userLoading}
											filterOptions={(options: any, state: any) => {
												return options;
											}}
										/>
									</Grid>
								)}

								{role === "mei" && (
									<Grid item xs={12} sm={6} md={4} lg={3}>
										<DatePicker
											value={birthDate}
											onChange={(date: any) => handleChange("birthDate", date)}
											format={ls.dateFormatShort}
											label={ls.birthDate}
											// emptyLabel="Selecione uma data"
										/>
									</Grid>
								)}

								<Grid item xs={12} sm={6} md={4} lg={3}>
									<TextInput
										errors={errors}
										id="phoneNumber"
										name="phoneNumber"
										value={phoneNumber}
										InputProps={{
											inputComponent: PHONE
										}}
										onChange={handleChange}
									/>
								</Grid>

								<Grid item xs={12} sm={6} md={4} lg={3}>
									<TextInput
										errors={errors}
										id="cpf"
										name={role === "mei" ? "cpf" : "cpfOrCnpj"}
										value={cpf}
										InputProps={{
											inputComponent: role === "mei" ? CPF : CPFCNPJ
										}}
										onChange={handleChange}
									/>
								</Grid>

								<Grid item xs={12} sm={6} md={4} lg={3}>
									<Select
										errors={errors}
										id="userStatus"
										name="userStatus"
										value={userStatus.toString()}
										onChange={handleChange}
										options={Object.values(UserStatus)
											.filter(c => !isNaN(Number(c)))
											.map((c: any) => ({
												id: c,
												value: ls[UserStatus[c]]
											}))}
									/>
								</Grid>

								<Grid item xs={12} />
								<Grid item xs={12} sm={6} md={4} lg={2}>
									<TextInput
										errors={errors}
										id="zipCode"
										name="zipCode"
										InputProps={{
											inputComponent: CEP
										}}
										value={zipCode}
										onChange={handleAddressChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={8}>
									<TextInput
										errors={errors}
										id="street"
										name="street"
										value={street}
										onChange={handleAddressChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={2}>
									<TextInput
										errors={errors}
										id="number"
										name="number"
										value={number}
										onChange={handleAddressChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={2}>
									<TextInput
										errors={errors}
										id="complement"
										name="complement"
										value={complement}
										onChange={handleAddressChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} lg={4}>
									<TextInput
										errors={errors}
										id="neighborhood"
										name="neighborhood"
										value={neighborhood}
										onChange={handleAddressChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} lg={4}>
									<TextInput
										errors={errors}
										id="city"
										name="city"
										required
										value={city}
										onChange={handleAddressChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={2}>
									<TextInput
										errors={errors}
										id="state"
										name="state"
										required
										inputProps={{
											maxLength: 2
										}}
										value={state}
										onChange={handleAddressChange}
									/>
								</Grid>
							</Grid>
						</AccordionDetails>
					</Accordion>
				</Grid>

				<Grid item xs={12}>
					<Grid container justifyContent="flex-end">
						<Grid item>
							<Button
								disabled={loading}
								variant="contained"
								color="secondary"
								type="submit"
							>
								Salvar
								{loading && <Spinner size={20} style={{ marginLeft: 16 }} />}
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</form>
	);
}

export default UserCreate;
